export class EmailInfo {
  public ContactId?: string;
  public IsPrimary?: boolean;
  public IsActive?: boolean;
  public Email?: string;
  public Type?: string;
}
